/* eslint-disable no-param-reassign */

/* eslint-disable no-continue */

function checkOverLapping(el) {
  const bookingAndTimeOff = document.querySelectorAll('.cal-entry-wrap');
  const elToBeChecked = el.children[0].children[1];

  const allComponents = [];
  bookingAndTimeOff.forEach((e) => allComponents.push(e));
  let overlap = false;
  let nextRect;
  const thisRect = elToBeChecked.getBoundingClientRect();
  nextRect = thisRect;
  let nextComponent;
  let overlappedComponent;

  if (thisRect && allComponents.length > 0) {
    for (let i = 0; i < allComponents.length; i += 1) {
      if (elToBeChecked === allComponents[i]) {
        nextRect = null;
        continue;
      }
      const cell = document.querySelector('.scheduler_item.for-column');
      let cellWidth = 0;
      if (cell) {
        cellWidth = cell.getBoundingClientRect().width;
      }
      let halfCell;
      if (i <= allComponents.length - 1) {
        nextRect = allComponents[i].getBoundingClientRect();
        halfCell = Math.abs(Math.round(thisRect.top - nextRect.top)) < 5 && Math.abs(Math.round(thisRect.width - cellWidth / 2)) < 5;
        if (Math.abs(nextRect.left - thisRect.left) > 1 && !halfCell) {
          // not the same column
          nextRect = null;
          continue;
        } else {
          nextComponent = allComponents[i];
        }
      }

      if (!nextRect) {
        return { overlop: false, overlappedComponent: null };
      }

      if (thisRect && nextRect) {
        let sameColumn = false;
        sameColumn = Math.abs(thisRect.left - nextRect.left) < 20 && Math.abs(thisRect.left + thisRect.width - (nextRect.left + nextRect.width)) < 20;
        let nextBelow = false;

        nextBelow = thisRect.top + thisRect.height > nextRect.top && thisRect.top < nextRect.top;

        const nextAbove = thisRect.top > nextRect.top && thisRect.top < nextRect.top + nextRect.height;

        if (halfCell || (sameColumn && (nextBelow || nextAbove))) {
          overlap = true;
          overlappedComponent = nextComponent;
          break; // found overlap, no need to check anymore
        }
      }
    }
  }
  return { overlap, overlappedComponent };
}

export default checkOverLapping;
window.checkOverLapping = checkOverLapping;
